import * as prefsActionsTypes from 'js/constants/prefsAction-types';

export const changeUserLanguage = (prefLng) => {
  return async (dispatch) => {
    return dispatch(changeLangEvent(prefLng));
  };
};

export const changeLangEvent = (lang) => ({
  type: prefsActionsTypes.PREF_LANG_CHANGED,
  lang,
});
